import { type GalleryEntry, galleryFor, madeWith } from '@shared/gallery'
import { Link } from 'react-router'
import { useI18n } from '@/i18n/i18n'

/** The example gallery on the board list: real conversations and the boards they made. */
export function GallerySection() {
  const { t, locale } = useI18n()
  const examples = galleryFor(locale)
  if (!examples.length) return null
  return (
    <section aria-labelledby="gallery-title" className="mt-12">
      <div className="mb-4 flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-3">
        <h2 id="gallery-title" className="text-[17px] font-semibold tracking-[-0.01em]">
          {t('gallery.title')}
        </h2>
        <p className="text-[13px] text-muted">{t('gallery.lede')}</p>
      </div>
      <ul className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-4">
        {examples.map((g) => (
          <GalleryTile key={g.slug} entry={g} />
        ))}
      </ul>
    </section>
  )
}

function GalleryTile({ entry }: { entry: GalleryEntry }) {
  const { t } = useI18n()
  return (
    <li>
      <Link
        to={`/gallery/${entry.slug}`}
        className="flex h-full min-h-32 flex-col rounded-lg border border-dashed border-line-strong bg-surface/60 p-4 transition-[border-color,background-color] duration-200 hover:border-solid hover:bg-surface"
      >
        <span className="mb-2 flex items-center gap-1.5 text-[11px] text-muted">
          <span className="rounded-sm bg-surface-2 px-1.5 py-px font-medium text-ink-2">
            {t(entry.category === 'learning' ? 'gallery.learning' : 'gallery.life')}
          </span>
          <span>{t(entry.language === 'en' ? 'gallery.inEn' : 'gallery.inZh')}</span>
          <span aria-hidden="true">·</span>
          <span>{madeWith(entry.made)}</span>
        </span>
        <span lang={entry.language} className="text-[15px] font-medium tracking-[-0.01em]">
          {entry.title}
        </span>
        <span
          lang={entry.language}
          className="mt-1 line-clamp-2 text-[12.5px] leading-relaxed text-muted"
        >
          {entry.blurb}
        </span>
      </Link>
    </li>
  )
}
